import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationMessage } from './notification-confirm.model';
@Component({
  selector: 'app-send-notification-confirmation-dialog',
  templateUrl: './send-notification-confirmation-dialog.component.html',
  styleUrls: ['./send-notification-confirmation-dialog.component.scss'],
})
export class SendNotificationConfirmationDialogComponent implements OnInit {
  confirmationMsg: NotificationMessage;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    if (data.value.status === -1) {
      this.confirmationMsg = data.value.error.errorMessage;
      console.log(this.confirmationMsg);
    } else {
      this.confirmationMsg = data.value.message;
    }
  }

  ngOnInit() {}
}
